/** @module resolve */ /** for typedoc */
export * from './interface';
export * from './resolvable';
export * from './resolveContext';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@uirouter/core/lib-esm/resolve/index.js
// module id = 179
// module chunks = 0